//@ts-check

const CosmosClient = require('@azure/cosmos').CosmosClient
export async function cosmosDBpost(driverName, email, mobile) {
  const CosmosClient = require('@azure/cosmos').CosmosClient

  const url = require('url')

  const endpoint = 'https://bobtreeinstance.documents.azure.com:443/'
  const key = 'Gugwvusfq83gNKJYT0oBg1vGXparZ6lYg3i7hpKtsg4JKuAEp2rOiYkSNVHeuRT6XxdgmBPrAd6RptTbhcpSog=='

  const databaseId = 'ToDoList';
  const containerId = 'Items';

  const partitionKey = { kind: 'Hash', paths: ['/partitionKey'] }

  const options = {
    endpoint: endpoint,
    key: key,
    userAgentSuffix: 'CosmosDBJavascriptQuickstart'
  };

  const client = new CosmosClient(options)

  /*
   * Create the database if it does not exist
   */
  async function createDatabase() {
    const { database } = await client.databases.createIfNotExists({
      id: databaseId
    })
    console.log(`Created database:\n${database.id}\n`)
  }

  async function createItem(itemBody) {
    const { item } = await client
      .database(databaseId)
      .container(containerId)
      .items.upsert(itemBody)
    console.log(`Created item with id:\n${itemBody.id}\n`)
  }

  /**
   * Cleanup the database and collection on completion
   */
  async function cleanup() {
    await client.database(databaseId).delete()
  }

  /**
   * Exit the app with a prompt
   * @param {string} message - The message to display
   */
  function exit(message) {
    console.log(message)
    process.exit()
  }

  let currentdate = new Date();
  let sentByApi = "thruReactoCosmos";

  const items = {
    "id": email,
    "partitionKey": mobile,
    "driverName": driverName,
    "signupTime": currentdate,
    "signUpMethod": sentByApi
  }

  createDatabase()
    .then(() => createItem(items))
  //.then(() => cleanup)
  //  .then(() => {
  //   exit(`Completed successfully`)
  //  })
  //  .catch(error => {
  //    exit(`Completed with error ${JSON.stringify(error)}`)
  //    })

}

